export function isFunction(val) {
  return typeof val === 'function';
}